import { createFileRoute } from '@tanstack/react-router'
import { ValueStories } from 'pages/valueStories/ValueStories'
import { z } from 'zod'

export const valueStoriesSearchSchema = z.object({})

export const Route = createFileRoute('/value-stories/$siteID/')({
  component: ValueStories,
  staticData: {
    title: 'Value Stories',
    layout: {
      enableScrolling: true,
    },
  },

  validateSearch: valueStoriesSearchSchema,
})
